import React, { useEffect, useRef } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

type DayRow = {
  day: string;
  units_ordered: number;
  units_cancelled: number;
  cancel_rate: number;
};

const CancelRateChart = ({ days }: { days: DayRow[] }) => {
  const idRef = useRef(`fbs-cancel-${Math.random().toString(36).slice(2)}`);

  useEffect(() => {
    const root = am5.Root.new(idRef.current);
    root.setThemes([am5themes_Animated.new(root)]);

    const chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: true,
        panY: false,
        wheelX: "panX",
        wheelY: "zoomX",
      })
    );

    const xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "day",
        renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 40 }),
      })
    );
    const yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        min: 0,
        numberFormat: "#.#'%'",
        renderer: am5xy.AxisRendererY.new(root, {}),
      })
    );

    const series = chart.series.push(
      am5xy.LineSeries.new(root, {
        name: "Cancel %",
        xAxis,
        yAxis,
        valueYField: "rate_pct",
        categoryXField: "day",
        tooltip: am5.Tooltip.new(root, {
          labelText: "{categoryX}: {valueY.formatNumber('#.##')}%",
        }),
      })
    );
    series.strokes.template.setAll({ strokeWidth: 2 });
    series.bullets.push(() =>
      am5.Bullet.new(root, {
        sprite: am5.Circle.new(root, { radius: 4, fill: series.get("fill") }),
      })
    );

    const data = days.map((d) => ({
      day: d.day,
      rate_pct: Math.round(d.cancel_rate * 1000) / 10,
    }));
    xAxis.data.setAll(data);
    series.data.setAll(data);
    chart.set("cursor", am5xy.XYCursor.new(root, {}));

    return () => root.dispose();
  }, [days]);

  return <div id={idRef.current} style={{ width: "100%", height: 260 }} />;
};

export default CancelRateChart;
